<template>
  <div>
    <el-button type="success" @click="exprotStu" icon="document"
      >导出学员</el-button
    >
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
export default {
  name: "exprotClassStuList",
  components: {},
  data() {
    return {};
  },
  props: {
    classId: {
      type: Number,
      default: null,
    },
    className: {
      type: String,
      default: "",
    },

  },
  created() {},
  watch: {},
  methods: {
    exprotStu() {
      let params = {
        appId: this.$API.APPID,
        classId: `${this.classId}`,
      };
      this.eduAxiosPostRequest("edu/eduAdmin/stu/export", params).then(
        (data) => {
          let blob = new Blob([data], {
            type: "application/vnd.ms-excel",
          });
          require("file-saver").saveAs(
            blob,
            `${this.className}.xlsx`
          );
          this.$message({
            type: "success",
            message: "导出成功, 正在下载中",
          });
          //   let currentURL = window.location.href;
          //   if (currentURL.indexOf("https") != -1) {
          //     if (url.indexOf("https") == -1) {
          //       let urlArr = url.split(":", 2);
          //       urlArr[0] = "https:";
          //       url = urlArr[0] + urlArr[1];
          //     }
          //   }
          //   console.log(url);
          //   this.$axios
          //     .get(url, {
          //       responseType: "blob",
          //     })
          //     .then((res) => {
          //       let blob = new Blob([res.data], {
          //         type: "application/csv",
          //       });
          //       if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //         // 兼容IE
          //         window.navigator.msSaveOrOpenBlob(blob, element.original_name);
          //       } else {
          //         let downloadElement = document.createElement("a");
          //         downloadElement.href = window.URL.createObjectURL(blob);
          //         downloadElement.download = this.className + ".csv";
          //         downloadElement.click();
          //         window.URL.revokeObjectURL(blob);
          //       }
          //     })
          //     .catch((error) => {
          //       console.error(error);
          //     });
        }
      );
    },

    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params, {
            responseType: "blob",
            headers: {
              "content-type": "application/json; charset=utf-8",
            },
          })
          .then((response) => {
            console.log(response);

            if (response.data) {
              // debugger;
              resolve(response.data);
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// exprotClassStuList.vue?2525e008